// extracted by mini-css-extract-plugin
export default {"centerContent":"CenterContent_centerContent__VfeFZ","projectContainer":"CenterContent_projectContainer__KHlIN","heroImage":"CenterContent_heroImage__1xRED"};